import React from 'react'
import { Theme } from '@material-ui/core'
import { GroupedDataTable } from '../components'
import {
    GroupedValuesByTerm,
    DeliverableValue,
    ResidentTermDirectoryRow,
} from '../../../../../models'

interface AuditModeProps {
    theme: Theme
    groupedValues: GroupedValuesByTerm[]
    selectedValueIds: number[]
    onCheckboxToggle: (valueId: number) => void
    onHeaderCheckboxChange: (groupValues: any[]) => void
    getGroupCheckboxState: (
        groupValues: any[],
    ) => {
        checked: boolean
        indeterminate: boolean
        disabled: boolean
    }
    isProcessing: boolean
    onViewDetails?: (
        value: DeliverableValue,
        row: ResidentTermDirectoryRow,
    ) => void
}

export const AuditMode: React.FC<AuditModeProps> = ({
    theme,
    groupedValues,
    selectedValueIds,
    onCheckboxToggle,
    onHeaderCheckboxChange,
    getGroupCheckboxState,
    isProcessing,
    onViewDetails,
}) => {
    return (
        <GroupedDataTable
            theme={theme}
            groupedValues={groupedValues}
            selectedValueIds={selectedValueIds}
            onCheckboxToggle={onCheckboxToggle}
            onHeaderCheckboxChange={onHeaderCheckboxChange}
            getGroupCheckboxState={getGroupCheckboxState}
            isProcessing={isProcessing}
            onViewDetails={onViewDetails}
        />
    )
}
